import React from 'react';
import _ from "underscore";
import Dropzone from 'react-dropzone';
import { sprintf } from 'sprintf-js';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { css_file_to_url } from "../../helper/css-util";
import { copyToClipboard } from "../../helper/clipboard";
import './style.scss';

import { TextEditor, createFontOptions } from './textEditor';
import WLFEntity from '../WLFList/wlfEntity';
import { ColorPicker } from './colorPicker';
import ImageLoader from './imageLoader';
import { getRGB } from "../../../lib/color";
import { ChartColors } from "../chart-colors";
import Loader from '../Loader';
import { UploadFile, SaveCSS, UpdateCSS } from "../../superadmin/actions";
import { deep_copy } from "../../../lib/js-utils";
import Logo from '../Logo/Logo';

const style = {
  dropzone:{
      "border": "1px solid #ccc",
      "padding": "5px",
      "background": "white",
      "backgroundRepeat": "no-repeat",
      "backgroundPosition": "center",
      "backgroundSize": "contain",
      'outline': 'none',
      'cursor': 'pointer'
  },
  uploadDoc:{
      "padding": "5px",
      "background": "white",
      "backgroundRepeat": "no-repeat",
      "backgroundPosition": "center",
      "backgroundSize": "contain",
      'outline': 'none',
      'cursor': 'pointer'
  }
};

const footerEntities = [
  "contact",
  "mobile",
  "press_room",
  "careers",
  "faq",
  "support",
  "security",
  "site-map",
  "ira",
  "investment_accounts",
  "college_investment_accounts",
  "terms",
  "privacy_policy",
  "form_adv_part_1",
  "form_adv_part_2"
];

function contentEditable(WrappedComponent) {

  return class extends React.Component {

    state = {
      editing: false
    };

    toggleEdit = (e) => {
      e.stopPropagation();
      if (this.state.editing) {
        this.cancel();
      } else {
        this.edit();
      }
    };

    edit = () => {
      this.setState({
        editing: true
      }, () => {
        this.domElm.focus();
      });
    };

    save = () => {
      this.setState({
        editing: false
      });
      this.props.onSave(this.domElm.textContent);
    };

    cancel = () => {
      this.setState({
        editing: false
      });
    };

    isValueChanged = () => {
      return this.props.value !== this.domElm.textContent
    };

    handleKeyDown = (e) => {
      const { key } = e;
      if (key === 'Enter' || key === 'Escape') {
        this.save();
      }
    };

    render() {
      const {editing} = this.state;
      const span_style = {
        paddingLeft: "1rem",
        fontSize: "1.5rem",
      };
      return (
        <WrappedComponent
          className={editing ? 'title editing' : 'title'}
          onClick={this.toggleEdit}
          contentEditable={editing}
          ref={(domNode) => {
            this.domElm = domNode;
          }}
          onBlur={this.save}
          onKeyDown={this.handleKeyDown}
          value={this.props.value}>

        {this.props.value}
        {!editing && <span style={span_style}><i className="fa fa-edit edit-iconnn"></i></span> }
      </WrappedComponent>
      )
    }
  }
}


class CSSEditor_ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedWlf: this.props.wlf,
      saving: false,
      uploading: false,
    };
  }

  getColour = (type) => {
    const {selectedWlf} = this.state;
    return selectedWlf.css.color[type];
  };

  handleColorChange = (color, type) => {
    let {selectedWlf} = this.state;
    selectedWlf.css.color[type] = color;
    this.setState({selectedWlf: {...selectedWlf}})
  };

  handleTextEdit = (textObj, type) => {
    let {selectedWlf} = this.state;
    selectedWlf.css[type] = textObj;
    this.setState({selectedWlf: {...selectedWlf}});
  };

  handleChangeAddress = e => {
    let {selectedWlf} = this.state;
    selectedWlf.css.address[parseInt(e.target.name, 10)] = e.target.value;
    this.setState({selectedWlf: {...selectedWlf}})
  }

  doUpload = (field, do_footer) => files => {
    const wlf_css = deep_copy(this.state.selectedWlf);
    const file = files[0];
    this.setState({ uploading: field });

    UploadFile(
      file,
      wlf_css.css.id,
      do_footer ? "footer/" + field : field,
      this.props.token)
      .then(new_file_path => {
        if (do_footer) {
          wlf_css.css.footer[field].url = new_file_path;
        } else {
          wlf_css.css[field] = new_file_path;
        }
        this.setState({
          uploading: false,
          selectedWlf: wlf_css,
        });
      })
  };

  toggleSelectAllFooterLinks = e => {
    let {selectedWlf} = this.state;
    _.each(footerEntities, entity => {
      if (!selectedWlf.css.footer[entity]) selectedWlf.css.footer[entity] = {};
      selectedWlf.css.footer[entity].show = e.target.checked;
      this.setState({selectedWlf: {...selectedWlf}})
    })

  }

  changeShowFooterLink = e => {
    let {selectedWlf} = this.state;
    if (!selectedWlf.css.footer[e.target.name]) selectedWlf.css.footer[e.target.name] = {};
    selectedWlf.css.footer[e.target.name].show = e.target.checked;
    this.setState({selectedWlf: {...selectedWlf}})
  }

  onChangeFooterLinkLabel = e => {
    let {selectedWlf} = this.state;
    if (!selectedWlf.css.footer[e.target.name]) selectedWlf.css.footer[e.target.name] = {};
    selectedWlf.css.footer[e.target.name].label = e.target.value;
    this.setState({selectedWlf: {...selectedWlf}})
  }

  onChangeURL = e => {
    let {selectedWlf} = this.state;
    if (!selectedWlf.css.footer[e.target.name]) selectedWlf.css.footer[e.target.name] = {};
    selectedWlf.css.footer[e.target.name].url = e.target.value;
    this.setState({selectedWlf: {...selectedWlf}})
  }

  onSave = () => {
    let {selectedWlf} = this.state;

    this.setState({saving: true});

    SaveCSS(selectedWlf, this.props.token)
      .then(() => {
        this.setState({saving: false});
        this.props.UpdateCSS(selectedWlf);
      });
  };

  changeDefaultFont = ev => {
    const newFont = ev.currentTarget.value;
    let {selectedWlf} = this.state;
    selectedWlf.css.default_font = newFont;
    this.setState({selectedWlf});
  };

  renderDefaultFontFace = () => {
    const selectedFont = this.state.selectedWlf.css.default_font;
    const fontFaces = createFontOptions();
    const spanStyle = {
      marginBottom: "1rem",
    };

    return (
      <p className="control">
        <span className="select" style={spanStyle}>
          <select onChange={this.changeDefaultFont} value={selectedFont}>
            {fontFaces}
          </select>
        </span>
      </p>
    );
  }

  DLFNameChanged = data => {
    console.log("DLFNameChanged", data);
    let {selectedWlf} = this.state;
    selectedWlf.clientInfo.name = data;
    this.setState({selectedWlf: selectedWlf});
  }

  updateChartColors = (data) => {
    const selectedWlf = this.state.selectedWlf;
    selectedWlf.css.chart_colors = data;
    this.setState({
      selectedWlf: {...selectedWlf},
    });
  };

  onImageKey = field => ev => {
    const KeyC = 67;
    if (ev.keyCode === KeyC && ev.ctrlKey) {
      const url = css_file_to_url(
        this.props.config, this.state.selectedWlf.css[field]);
      copyToClipboard(url);
      console.log("Copied", url, "to clipboard");
    }
  };

  onMouseEnter = (do_enter, field) => ev => {
    if (ev.target.id !== field) {
      return;
    }

    if (do_enter) {
      ev.target.focus();
    } else {
      ev.target.blur();
    }
   };

  render() {
    const {selectedWlf, uploading, saving} = this.state;

    const cancel_url = '/super-admin/css-editor';

    if (!selectedWlf) return null;
    if (saving) return <Loader/>;

    let EditableH1 = contentEditable('h1');
    const logo_url = css_file_to_url(this.props.config, selectedWlf.css.logo);
    const landing_url = css_file_to_url(this.props.config, selectedWlf.css.landing_page_image);
    const footer_logo_url = css_file_to_url(this.props.config, selectedWlf.css.footer_logo);

    const get_drop_props = field => {
      return {
        onKeyDown: this.onImageKey(field),
        onMouseEnter: this.onMouseEnter(true, field),
        onMouseLeave: this.onMouseEnter(false, field),
        id: field,
      }
    };

    const dumpColorColumn = (items) => {
      const elems = [];
      items.forEach(({label, color_id}) => {
        elems.push((
          <div key={color_id}>
            <span>{label}</span>
            <ColorPicker type={color_id} getColour={this.getColour} onChange={this.handleColorChange}/>
          </div>
        ))
      });
      return (
        <div className="column is-4">
          { elems }
        </div>
      )
    };

    return (
      <div className='css-editor'>
        <nav className="level">
          <div className="level-left">
            <div className="level-item">
              <EditableH1 value={selectedWlf.clientInfo.name} onSave={this.DLFNameChanged}/>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <Link to={cancel_url} className='button is-text close-btn'>
                <i className="fa fa-times"></i>
              </Link>
            </div>
          </div>
        </nav>

        <div className="columns">
          <div className="column is-4">
            <WLFEntity wlf={selectedWlf}/>
          </div>
          <div className="column is-8">

            <div className="columns address-columns">
              <div className="column is-4">
                <Dropzone onDrop={this.doUpload('logo', false)} multiple={false}>
                  {({getRootProps, getInputProps}) => (
                    <div
                      {...getRootProps()}
                      style={{...style.dropzone}}
                      {...get_drop_props('logo')}
                    >
                      <input {...getInputProps()} />
                      {
                        uploading === 'logo' ? <ImageLoader/> :
                          <img src={logo_url} alt='Logo' style={{height: '50px'}}/>
                      }
                      <p>Change Logo</p>
                    </div>
                  )}
                </Dropzone>
              </div>
              <div className='column is-4'>
                <Dropzone onDrop={this.doUpload('footer_logo', false)} multiple={false}>
                    {({getRootProps, getInputProps}) => (
                      <div
                        {...getRootProps()}
                        style={{...style.dropzone}}
                        {...get_drop_props('footer_logo')}
                      >
                        <input {...getInputProps()} />
                        {
                          uploading === 'footerLogo' ? <ImageLoader/> : 
                            <Logo 
                              src={footer_logo_url} 
                              alt={'Footer Logo'} 
                              logo={selectedWlf.css.footer_logo} 
                              style={{height: '50px'}}
                              hidden={!selectedWlf.css.footer_logo}
                              hiddenStyle={{height: '56px'}}
                            />
                        }
                        <p>Change Footer Logo</p>
                      </div>
                    )}
                </Dropzone>
              </div>
              <div className="column is-4">
                <Dropzone onDrop={this.doUpload('landing_page_image', false)} multiple={false}>
                  {({getRootProps, getInputProps}) => (
                    <div
                      {...getRootProps()}
                      style={{...style.dropzone}}
                      {...get_drop_props('landing_page_image')}
                    >
                      <input {...getInputProps()} />
                      {
                        uploading === 'landingPageImage' ? <ImageLoader/> :
                          <img src={landing_url} alt='Landing Page' style={{height: '50px'}}/>
                      }
                      <p>Change Landing Page Image</p>
                    </div>
                  )}
                </Dropzone>
              </div>
              <div className="column is-4">
                { /* BLANK */ }
              </div>
            </div>

            <div className="columns">

              { dumpColorColumn([
                { label: "Top Panel Tint", color_id: 'top_panel_tint'},
                { label: "Sign On Background", color_id: 'sign_on_background'},
                { label: "Sign On/Start Invest Button", color_id: 'sign_on_button'},
                { label: "Sign On Panel Text", color_id: 'sign_on_panel_text'},
              ])}

              { dumpColorColumn([
                { label: "Footer Background", color_id: "footer_background"},
                { label: "Footer Primary Text", color_id: "footer_primary_text"},
                { label: "Footer Secondory Text", color_id: "footer_secondary_text"},
              ])}

              { dumpColorColumn([
                { label: "Banner", color_id: "banner_background"},
                { label: "Banner Text", color_id: "banner_text"},
                { label: "Onboarding Banner", color_id: "onboarding_banner_background"},
                { label: "Onboarding Banner Text", color_id: "onboarding_banner_text"},
              ])}

            </div>
          </div>
        </div>

        <div>
          <h5 className='title is-6' style={{margin: '12px 0', marginTop: '2rem'}}>Chart colors</h5>
          <ChartColors css={selectedWlf.css} onChange={this.updateChartColors}/>
        </div>

        <div className="footer-table">
          <h5 className='title is-6' style={{margin: '12px 0', marginTop: '2rem'}}>Default Font Face</h5>
          {this.renderDefaultFontFace()}
        </div>

        <div className="columns">
          <div className="column is-6">
            <TextEditor title='Top Panel Text' type='top_panel_text' wlf={selectedWlf} onChange={this.handleTextEdit}/>
          </div>
          <div className="column is-6">
            <TextEditor title='Home Page Text' type='home_page_text' wlf={selectedWlf} onChange={this.handleTextEdit}/>
          </div>
        </div>

        <div className="columns">
          <div className="column is-6">
            <TextEditor title='Mid Panel Top Text' type='mid_panel_top_text' wlf={selectedWlf}
                        onChange={this.handleTextEdit}/>
          </div>
          <div className="column is-6">
            <TextEditor title='Mid Panel Bottom Text' type='mid_panel_bottom_text' wlf={selectedWlf}
                        onChange={this.handleTextEdit}/>
          </div>
        </div>

        <div className="columns address-columns">
          <div className="column is-3">
            <div className="field">
              <label className="label">Address 1</label>
              <div className="control">
                <input className="input" type="text"
                       placeholder="Address 1"
                       name='0'
                       value={selectedWlf.css.address[0]}
                       onChange={this.handleChangeAddress}/>
              </div>
            </div>
          </div>
          <div className="column is-3">
            <div className="field">
              <label className="label">Address 2</label>
              <div className="control">
                <input className="input" type="text"
                       placeholder="Address 2"
                       name='1'
                       value={selectedWlf.css.address[1]}
                       onChange={this.handleChangeAddress}/>
              </div>
            </div>
          </div>
          <div className="column is-3">
            <div className="field">
              <label className="label">Phone</label>
              <div className="control">
                <input className="input" type="text" placeholder="Phone"
                       value={selectedWlf.css.phone}
                       onChange={e => this.handleTextEdit(e.target.value, 'phone')}/>
              </div>
            </div>
          </div>
          <div className="column is-3">
            <div className="field">
              <label className="label">URL</label>
              <div className="control">
                <input className="input" type="text" placeholder="URL"
                       value={selectedWlf.css.url}
                       onChange={e => this.handleTextEdit(e.target.value, 'url')}/>
              </div>
            </div>
          </div>
        </div>


        <div className="footer-table">
          <h5 className='title is-6' style={{margin: '12px 0', marginTop: '20px'}}>Footer Text</h5>
          <div className="columns address-columns">
            <div className="column is-6">
              <div className="field">
                <label className="label">Start Investing Button - Link</label>
                <div className="control">
                  <input className="input" type="text"
                         placeholder="Start Investing Button - Link"
                         value={selectedWlf.css.start_investing_button_link}
                         onChange={e => this.handleTextEdit(e.target.value, 'start_investing_button_link')}/>
                </div>
              </div>
            </div>
            <div className="column is-6">
              <div className="field">
                <label className="label">Sign On Button - Link</label>
                <div className="control">
                  <input className="input" type="text"
                         placeholder="Sign On Button - Link"
                         value={selectedWlf.css.sign_on_button_link}
                         onChange={e => this.handleTextEdit(e.target.value, 'sign_on_button_link')}/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-table">
          <h5 className='title is-6' style={{margin: '12px 0', marginTop: '20px'}}>Footer Text</h5>
          <div className="columns address-columns">
            <div className="column is-6">
              <div className="field">
                <label className="label">Support Email</label>
                <div className="control">
                  <input className="input" type="text"
                         placeholder="Support Email"
                         value={selectedWlf.css.support_email}
                         onChange={e => this.handleTextEdit(e.target.value, 'support_email')}/>
                </div>
              </div>
              <div className="field">
                <label className="label">Copyright Info</label>
                <div className="control">
                  <input className="input" type="text"
                         placeholder="Copyright Info"
                         value={selectedWlf.css.copyright_info}
                         onChange={e => this.handleTextEdit(e.target.value, 'copyright_info')}/>
                </div>
              </div>
            </div>
            <div className="column is-6">
              <div className="field">
                <label className="label">Disclosure Info</label>
                <div className="control">
                    <textarea className="textarea" rows="3"
                              placeholder="Disclosure Info"
                              value={selectedWlf.css.disclosure_info}
                              onChange={e => this.handleTextEdit(e.target.value, 'disclosure_info')}/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-table">
          <h5 className='title is-6' style={{margin: '12px 0', marginTop: '20px'}}>Footer Links</h5>
          <table className="table is-bordered  is-narrow is-hoverable is-fullwidth">
            <thead>
            <tr>
              <th style={{width: '25px'}}>
                <input type="checkbox" onClick={this.toggleSelectAllFooterLinks}/>
              </th>
              <th>Label</th>
              <th>URL</th>
              <th style={{width: '200px'}}>File</th>
            </tr>
            </thead>
            {_.map(footerEntities, (entity, index) => {
              const key = sprintf("tbody-%d", index);
              return (
                <tbody key={key}>
                <tr>
                  <td>
                    <input type="checkbox" name={entity}
                           checked={selectedWlf.css.footer[entity] ? selectedWlf.css.footer[entity].show : false}
                           onChange={this.changeShowFooterLink}/>
                  </td>

                  {/* Edit Label */}
                  <td>
                    <input
                      className="input" name={entity}
                      type="text" placeholder={entity}
                      value={selectedWlf.css.footer[entity] ? selectedWlf.css.footer[entity].label : ''}
                      onChange={this.onChangeFooterLinkLabel}/>
                  </td>

                  {/* Edit URL */}
                  <td>
                    <input
                      className="input" name={entity}
                      type="text" placeholder="URL"
                      value={selectedWlf.css.footer[entity] ? selectedWlf.css.footer[entity].url : ''}
                      onChange={this.onChangeURL}/>
                  </td>

                  {/* Upload Docs */}
                  <td>
                    <Dropzone onDrop={this.doUpload(entity, true) } multiple={false}>
                      {({getRootProps, getInputProps}) => (
                        <div
                          {...getRootProps()}
                          style={{...style.uploadDoc}}
                        >
                          <input {...getInputProps()} />
                          <p style={{textAlign: 'center'}}>
                            <i className="fa fa-upload"></i>
                            <span>{' '}Upload Document</span>
                          </p>
                        </div>
                      )}
                    </Dropzone>
                  </td>
                </tr>
                </tbody>
              )
            })}
          </table>
        </div>

        <nav className="level" style={{marginTop: '50px'}}>
          <div className="level-left">

          </div>
          <div className="level-right">
            <div className="level-item">
              <Link to={cancel_url} className='button is-text'>
                Cancel
              </Link>
            </div>
            <div className="level-item">
              <a className='button is-primary' onClick={this.onSave}
                 style={{backgroundColor: getRGB(selectedWlf.css.color.sign_on_button)}}>
                Save
              </a>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    UpdateCSS: selectedWlf => { dispatch(UpdateCSS(selectedWlf)) },
  }
};

const mapStateToProps = state => {
  return {
    config: state.app.config,
    token: state.user.token,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CSSEditor_);
